module.exports = __webpack_public_path__ + "img/UserIndicar_Símbolo_1.d3f4c8a9.png";